import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class CategoryListItem extends Component {
  render () {
    const { id, name, imageUrl, seq } = this.props;
    return (
      <li className={`@0-${seq}`}>
        <a href={`/portal/categories/${id}`} className="link_cate"
           data-tiara-id={id} data-tiara-type="categoryId"
           data-tiara-name={name} data-tiara-ordnum={seq}
           id={`category_${seq}`}
        >
          <span className="ico_cate">
          <img src={imageUrl} width={44} height={44} className="img_cate" alt=""/>
          </span>
          <span className="txt_cate">{name}</span>
        </a>
      </li>
    );
  }
}

CategoryListItem.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  seq: PropTypes.number.isRequired
};


// WEBPACK FOOTER //
// ./src/components/CategoryList/CategoryListItem.js